<div class="user-list">
    <!-- Back Button -->
    <button mat-button class="btn btn-danger" (click)="goBack()">Back</button>
    
    <div class="header">Users List</div>
    <div class="users">
      <div class="user" *ngFor="let user of all_user">
        <div class="user-info">
          <img [src]="user.image" alt="User Image" class="user-image" />
          <div>
            <div class="user-name">{{ user.name }}</div>
            <div class="user-email">{{ user.email }}</div>
          </div>
        </div>
        <button mat-icon-button [ngClass]="{'selected': user.selected}" (click)="toggleSelect(user)">
          <mat-icon>{{ user.selected ? 'check_circle' : 'add_circle' }}</mat-icon>
        </button>
      </div>
    </div>
    <!-- Submit Button -->
  <button mat-raised-button color="primary" class="btn btn-success" (click)="onSubmit()">Submit</button>
</div>